<script>
	import { onMount } from 'svelte';
	import { goto, ready } from '@roxi/routify';
	import SvelteTable from "svelte-table";
	import { getData, getGETAPILink, postFormData, searchTypeToName } from "../helpers.js";
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";

	let historyErrorField = '';
	let userStatErrorField = '';

	let username = 'Hi,';
	let accountValidity = true;
	let accountValidityLoaded = false;
	let lifetime_valid = false;
	let subscriptionType = ''
	let accountValidityErrorText = '';
	let periodDownloadFiles = '-';
	let recentSearchData = [];

	let usernamePromise = getData('user/get-username');
	usernamePromise.then(response => response.json())
	.then(ret_json => {
		if (ret_json.status === 'success') {
			username = 'Hi ' + ret_json.username;
		} else {
			username = '';
			userStatErrorField = '<An Unknown Error Occured>';
		}
	});

	let accValidityPromise = getData('user/account-validity');
	accValidityPromise.then(response => response.json())
	.then(ret_json => {
		if (ret_json.status === 'success') {
			accountValidity = ret_json.valid;
			if (accountValidity) {
				lifetime_valid = ret_json.lifetime_valid
			} else {
				accountValidityErrorText = ret_json.error_text;
			}
			accountValidityLoaded = true;
		} else {
			userStatErrorField = '<An Unknown Error Occured>';
		}
	});

	let subscriptionTypePromise = getData('user/subscription-type');
	subscriptionTypePromise.then(response => response.json())
	.then(ret_json => {
		if (ret_json.status === 'success') {
			subscriptionType = ret_json.subscription_type
		} else {
			subscriptionType = '<An Unknown Error Occured>';
		}
	});

	let periodDownloadsPromise = getData('user/get-period-files-downloaded');
	periodDownloadsPromise.then(response => response.json())
	.then(ret_json => {
		if (ret_json.status === 'success') {
			periodDownloadFiles = ret_json.count;
		} else {
			userStatErrorField = '<An Unknown Error Occured>';
		}
	});

	let recentSearchDataPromise = getData('search/historical', {'page': 0, page_limit: 5})
	recentSearchDataPromise.then(response => response.json())
	.then(ret_json => {
		if (ret_json.status === 'success') {
			recentSearchData = ret_json.data;
		} else {
			historyErrorField = 'An Unknown Error Occured';
		}
	});

	Promise.allSettled([usernamePromise, accValidityPromise, periodDownloadsPromise, recentSearchDataPromise])
	.then(() => {
		// this is not SSR, so it doesn't actually do anything. Go figure. - HC
		$ready();
	});

	// Recent History Code
	let sortBy = "creation_time";
	let sortOrder = 1;
	let iconAsc = "↑";
	let iconDesc = "↓";
	let numRows = 5;
	
	let dateOptions = {}
	const COLUMNS = {
		id: {
			key: "id",
			title: "Search ID",
			value: v => v.id.slice(0,10),
			sortable: false,
			headerClass: "bg-gray-200",
		},
		creationTime: {
			key: "creationTime",
			title: "Search Time",
			value: v => new Date(v.creation_time*1000).toLocaleString('en-US'),
			sortable: true,
			headerClass: "bg-gray-200",
		},
		searchType: {
			key: "searchType",
			title: "Search Type",
			value: v => searchTypeToName(v.search_type),
			sortable: true,
			headerClass: "bg-gray-200",
		},
		statusName: {
			key: "statusName",
			title: "Status",
			value: v => v.status_name,
			sortable: true,
			headerClass: "bg-gray-200",
		},
		downloadMetadata: {
			key: "downloadMetadata",
			title: "Metadata",
			parseHTML: true,
			value: v => {
				// if (v.status_name !== 'ERROR') {
				return `<a href="${getGETAPILink("search/metadata", {"search_id":v.id })}" download="${v.id + "_metadata.txt"}" target="_self"><button class="w-full border-none">⭳</button></a>`;
				// } else {
				// 	return 'X'
				// }
			},
			sortable: false,
			headerClass: "bg-gray-200",
		},
		downloadFile: {
			key: "downloadFile",
			title: "Zip File",
			parseHTML: true,
			value: v => {
				// let type = searchTypeToName(v.search_type);
				if (v.status_name === 'FINISHED' || v.status_name === 'ARCHIVED') {
					return `<a href="${getGETAPILink("search/download", {"search_id":v.id })}" download="${v.id + ".zip"}" target="_self"><button class="w-full border-none">⭳</button></a>`;
				} else if (v.status_name === 'ERROR') {
					return 'X';
				} else {
					return '-';
				}
			},
			sortable: false,
			headerClass: "bg-gray-200",
		},
	};
	let selectedDesktopCols = ["id", "searchType", "creationTime", "statusName", "downloadMetadata", "downloadFile"];
	$: desktopCols = selectedDesktopCols.map(key => COLUMNS[key]);

	let selectedMobileCols = ["id", "statusName"];
	$: mobileCols = selectedMobileCols.map(key => COLUMNS[key]);

	let expandedArr = [];
	function handleRowClick(event) {
		// manually toggle expanded items
		const row = event.detail.row;
		if (!row.$expanded) {
			expandedArr = [...expandedArr, row.id];
		} else {
			expandedArr = expandedArr.filter(id => id !== row.id);
		}
	}
</script>

<main class="background">
	<Navbar/>
	<div class="lg:mx-48 md:mx-32 sm:mx-8">
		<div class="flex flex-col space-y-4 mt-10 items-stretch lg:items-stretch lg:flex-row lg:space-y-0 lg:space-x-4">
			<div class="mx-2 px-8 py-6 lg:w-4/12 lg:px-16 lg:py-16 card">
				<p class="text-2xl font-semibold text-blue-900 mb-8">User Information</p>
				<p class="text-xl text-red-500">{userStatErrorField}</p>
				<div class='text-xl font-normal mb-6'>	
					<p>{username}</p>
					{#if accountValidityLoaded}
					<p>Account Status: {accountValidity ? 'Valid' : 'Invalid'}</p>
					<p class="text-red-500">{accountValidityErrorText}</p>
					{/if}
					<p class="{subscriptionType ? "" : "hidden"}">Subscription Type: {subscriptionType}</p>
					{#if accountValidity && subscriptionType == "NONE"}
					<p>Subscription cancelling at the end of this period.</p>
					{/if}
					{#if lifetime_valid}
					<p>You have an enterprise account.</p>
					{/if}
					<br>
					<p>You have downloaded {periodDownloadFiles} {periodDownloadFiles == 1 ? 'file' : 'files'} this period.</p>
				</div>
				<div class='flex-col space-y-4'>
					<button on:click={$goto('/user-info-menu')}
					class="px-4 pb-2.5 pt-1.5 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
					Edit User Information</button>
				</div>
			</div>
			<div class="mx-2 lg:!mb-0 px-8 py-4 lg:w-8/12 lg:px-16 lg:py-16 card z-[90]">
				<p class="text-2xl font-semibold text-blue-900 mb-2 mt-4 lg:mt-0">Recent Searches</p>
				<p class="text-md mb-8 block lg:hidden">(Click to Expand)</p>
				<p class="text-xl text-red-500">{historyErrorField}</p>
				{#if recentSearchData.length !== 0}
					<!-- Shown on large screen -->
					<div class="hidden lg:block">
						<SvelteTable
							columns={desktopCols}
							rows={recentSearchData}
							classNameRow={'text-lg text-center odd:bg-white even:bg-gray-200'}
							classNameThead={['table-primary sticky top-0 bg-white']}
							classNameTbody={['w-full overflow-scroll']}
							classNameSelect={['rounded-md shadow-sm font-thin py-1 px-2']}
						/>
					</div>
					<!-- Shown on mobile -->
					<div class="block lg:hidden">
						<SvelteTable
							columns={mobileCols}
							rows={recentSearchData}
							classNameRow={'cursor-pointer text-lg text-center'}
							classNameThead={['table-primary sticky top-0 bg-white']}
							classNameTbody={['w-full overflow-scroll']}
							classNameSelect={['rounded-md shadow-sm font-thin py-1 px-2']}
							classNameRowExpanded={'bg-gray-400'}
							classNameExpandedContent={'bg-gray-200'}
							classNameCell={'py-2'}
							expandRowKey="id"
							bind:expanded={expandedArr}
							on:clickRow={handleRowClick}
						>
						<svelte:fragment slot="expanded" let:row>
							<p class="text-center">Search Time: {new Date(row.creation_time*1000).toLocaleString('en-US')}</p>
							{#if row.status_name !== 'ERROR'}
								<a class="text-blue-500 visited:text-blue-500" href="{getGETAPILink("search/metadata", {"search_id":row.id })}" download="{row.id}_metadata.txt" target="_self">
									<button class="w-full border-none">⭳ Download Metadata ⭳</button>
								</a>
								{#if row.status_name === 'FINISHED'}
									<a class="text-blue-500 visited:text-blue-500" href="{getGETAPILink("search/download", {"search_id":row.id })}" download="{row.id}_metadata.txt" target="_self">
										<button class="w-full border-none">⭳ Download File ⭳</button>
									</a>
								{/if}
							{/if}
						</svelte:fragment>
						</SvelteTable>
					</div>
				{:else}
					<p class="text-xl">No Recent Data Found</p>
				{/if}
			</div>
		</div>
		<Footer/>
	</div>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}
</style>